import { createContext } from "react";

export type AuthContextType = {
  setUser: (user: any) => void;
};

const AuthContext = createContext<AuthContextType>({
  setUser: () => {},
});

export default AuthContext;
